import React from "react";

import { Box } from "arkh";
import { Image } from "expo-image";

export function WidgetFileMockPreview() {
  return (
    <Box color="border-primary" style={{ flex: 1 }} space="medium">
      <Image
        source={require("./dummy-file.png")}
        style={{ flex: 1 }}
        contentFit="contain"
      />
    </Box>
  );
}
